import { Chip, Tooltip, Box } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { green, orange, red } from "@mui/material/colors";
import { RiskAssessmentResult } from "./types/risk-search-response"; // adjust import path

interface RiskAssessmentResultInterface {
  level: RiskAssessmentResult | undefined;
}

const RiskLevelBadge = ({ level }: RiskAssessmentResultInterface) => {
  if (!level) return null;

  const config = {
    [RiskAssessmentResult.Green]: {
      label: "Low Risk",
      title: (
        <span>
          The criteria entered has not matched against the DTection database. If
          you have any concerns or would like to discuss your case further,
          please contact us via email at{" "}
          <a style={{ color: "#fff" }} href="http://www.Dtection@keoghs.co.uk">
            DTection@keoghs.co.uk
          </a>
        </span>
      ),
      color: green[800],
      background: green[50],
      borderColor: green[200],
    },
    [RiskAssessmentResult.Amber]: {
      label: "Medium Risk",
      title: (
        <span>
          The criteria entered has returned a match against the DTection
          database, but has not triggered any of our high risk indicators. If
          you have any concerns or would like to discuss your case further,
          please contact us via email at{" "}
          <a style={{ color: "#fff" }} href="http://www.Dtection@keoghs.co.uk">
            DTection@keoghs.co.uk
          </a>
        </span>
      ),
      color: orange[800],
      background: orange[50],
      borderColor: orange[200],
    },
    [RiskAssessmentResult.Red]: {
      label: "High Risk",
      title: (
        <span>
          The criteria entered has returned a match against the DTection
          database and has triggered one or more of our high risk indicators. If
          you have any concerns or would like to discuss your case further,
          please contact us via email at{" "}
          <a style={{ color: "#fff" }} href="http://www.Dtection@keoghs.co.uk">
            DTection@keoghs.co.uk
          </a>
        </span>
      ),
      color: red[800],
      background: red[50],
      borderColor: red[200],
    },
  }[level];

  return (
    <Box
      data-testid="risk-level-badge"
      display="flex"
      alignItems="center"
      gap={0.5}
      fontWeight={600}
    >
      <Chip
        label={config.label}
        sx={{
          backgroundColor: config.background,
          color: config.color,
          border: `1px solid ${config.borderColor}`,
          borderRadius: "8px",
          fontWeight: 600,
          px: 1.5,
          py: 0.5,
          height: "auto",
        }}
        variant="outlined"
      />
      <Tooltip title={config.title} placement="top">
        <InfoOutlinedIcon sx={{ fontSize: 16 }} />
      </Tooltip>
    </Box>
  );
};
export default RiskLevelBadge;
